
import { useFileHandling } from './hooks/useFileHandling';
import { useUploadActions } from './hooks/useUploadActions';

export const useProductUpload = (onUploadComplete: () => void) => {
  const {
    file,
    previewData,
    isProcessing,
    parseErrors,
    fileInputRef,
    handleFileChange,
    handleReset,
    setPreviewData
  } = useFileHandling();

  const {
    bulkCreateProducts,
    handleUpload,
    downloadTemplate,
    downloadTestFile
  } = useUploadActions(onUploadComplete, handleReset);

  return {
    file,
    previewData,
    isProcessing,
    parseErrors,
    fileInputRef,
    bulkCreateProducts,
    handleFileChange,
    handleUpload: () => handleUpload(previewData),
    handleReset,
    downloadTemplate,
    downloadTestFile,
  };
};
